import type React from "react";
import { CustomCheckbox } from "~/components/ui/check_Box";
import styles from "../../index.module.scss";
import type { BooleanFieldComponentProps } from "../../types";

const RichTextOptions: React.FC<BooleanFieldComponentProps> = ({
  options,
  handleBooleanOptionChange,
  isReadOnly,
}) => {
  // テキスト表示オプション
  const richTextDisplayOptions = [
    { key: "required", label: "必須項目にする" },
    { key: "noLabel", label: "フィールド名を表示しない" },
  ];

  return (
    <>
      {richTextDisplayOptions.map((option) => (
        <div key={option.key} className={styles["form-group"]}>
          <CustomCheckbox
            label={option.label}
            checked={options[option.key] || false}
            onChange={(value) => handleBooleanOptionChange(option.key, value)}
            {...(isReadOnly !== undefined && { disabled: isReadOnly })}
          />
        </div>
      ))}
    </>
  );
};

export default RichTextOptions;
